module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "dropdown confirmation"
  }, [_c('button', {
    staticClass: "btn",
    class: _vm.triggerBtnClass,
    attrs: {
      "type": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.triggerBtnHtml)
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "dropdown-menu ",
    class: [_vm.getDirection, _vm.size],
    style: (_vm.styleObj),
    attrs: {
      "aria-labelledby": "dropdownMenuButton"
    }
  }, [_vm._t("default", [_c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.alertMode),
      expression: "!alertMode"
    }],
    staticClass: "btn btn-sm btn-clear",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    class: _vm.confirmBtnClass,
    domProps: {
      "innerHTML": _vm._s(_vm.confirmBtnHtml)
    },
    on: {
      "click": function($event) {
        _vm.$emit('confirm');
        _vm.visible = false;
      }
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c85b426!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/DropdownConfirmation.vue
// module id = 408
// module chunks = 0